import { render } from "./AddressForm.vue?vue&type=template&id=d74ed684"
import script from "./AddressForm.vue?vue&type=script&lang=js"
export * from "./AddressForm.vue?vue&type=script&lang=js"
script.render = render

export default script